// utils/PlatformRedirect.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

const PlatformRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Ensure this only runs on the homepage
    if (location.pathname !== "/") return;

    const isMobile = Capacitor.isNativePlatform();

    if (isMobile) {
      const userId = localStorage.getItem("userID");

      if (userId) {
        navigate("/dashboard", { replace: true });
      } else {
        navigate("/demo", { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return null;
};

export default PlatformRedirect;
